<template>
<div class="z-0">
  <carousel :per-page="1" pagination-position="bottom-overlay" pagination-color="#cbd5e0" pagination-active-color="#777777"
  :pagination-padding="4" :mouse-drag="true" :pagination-size="10" :center-mode="true" :autoplay="true"
  :autoplayHoverPause="true" :loop="true" :autoplayTimeout="5000">
    <slide
      v-for="slide in slides"
      :key="slide.id"
    >
      <div class="hidden md:flex justify-center items-center w-full relative">
        <div class="absolute flex flex-col items-center left-3 w-2/5">
          <h1 class="text-3xl left-2 font-light uppercase" v-if="slide.text" :class="'text-'+slide.text_color">
            {{ slide.text }} </h1>
          <a
            v-if="slide.button_text"
            :href="slide.button_link"
            class="sticky mt-8 self-start border-2 border-b2c-red-300 rounded-full h-10 w-32
            hover:text-b2c-red-300 hover:bg-white bg-b2c-red-300 font-bold text-white
            flex items-center text-center justify-center">
              {{ slide.button_text }}
          </a>
        </div>
        <div class="w-full ">
          <img :src="slide.url_photo">
        </div>
      </div>

      <div class="md:hidden flex justify-center items-center w-full relative">
        <div class="absolute flex flex-col items-center font-medium left-1 w-2/3">
          <h1 class="text-xl md:text-2xl uppercase" v-if="slide.text" :class="'text-'+slide.text_color">
            {{ slide.text }} </h1>
          <a
            :href="slide.button_link" v-if="slide.button_text"
            class="sticky mt-5 self-start border-2 border-b2c-red-300 rounded-full h-10 w-32
            hover:text-b2c-red-300 hover:bg-white bg-b2c-red-300 font-bold text-white
            flex items-center justify-center">
              {{ slide.button_text }}
          </a>
        </div>
        <div class="w-full">
          <img :src="slide.url_photo_mobile">
        </div>
      </div>

    </slide>
    <!--<slide>
      <div class="md:flex justify-center items-center hidden relative">
        <div class="absolute flex flex-col items-center left-3 w-2/5">
          <h1 class="md:text-3xl lg:text-4xl font-light text-gray-300 leading-12">
           {{ $t('carousel.title2') }} </h1>
          <button
            @click="goToAccessories()" :aria-label="$t('carousel.discover')"
            class="sticky mt-8 self-start border-2 border-b2c-red-300 rounded-full h-10 w-32
            hover:text-b2c-red-300 hover:bg-white bg-b2c-red-300 font-bold text-white">
              {{ $t('carousel.discover') }}
          </button>
        </div>
        <div class="w-full ">
          <img src="/Carousel.png" alt="Harp cover">
        </div>
      </div>

      <div class="flex justify-center items-center relative md:hidden">
        <div class="absolute flex flex-col items-center left-1 w-1/2">
          <h1 class="text-xl md:text-2xl text-gray-300">
           {{ $t('carousel.title2') }} </h1>
          <button
            @click="goToAccessories()" :aria-label="$t('carousel.discover')"
            class="sticky mt-5 self-start border-2 border-b2c-red-300 rounded-full h-10 w-32
            hover:text-b2c-red-300 hover:bg-white bg-b2c-red-300 font-bold text-white">
              {{ $t('carousel.discover') }}
          </button>
        </div>
        <div class="w-full">
          <img src="/Carousel_mobile.png" alt="Harp cover">
        </div>
      </div>

    </slide>-->
  </carousel>
</div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  components: {
    Carousel,
    Slide,
  },

  data() {
    return {
      slides: [],
    };
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
    }),
  },

  watch: {
    changedLocale() {
      this.getCarouselSlides();
    },
  },

  created() {
    this.getCarouselSlides();
  },

  methods: {
    /* goToConfigurator() {
      this.$router.push('/configurator');
    },
    goToAccessories() {
      this.$router.push('/product-categories/acc');
    }, */

    getCarouselSlides() {
      axios.get('/api/carousel-photos').then(({ data }) => {
        this.slides = data;
        console.log(this.slides);
      });
    },
  },
};
</script>
